App.config([
    '$routeProvider',
    function($routeProvider) {
        $routeProvider
            .when('/', {
                templateUrl: 'components/auth/login/loginView.html',
                controller: 'LoginCtrl',
                controllerAs: 'vm'
            })

            .when('/login', {
                templateUrl: 'components/auth/login/loginView.html',
                controller: 'LoginCtrl',
                controllerAs: 'vm'
            })

            .when('/reset-password', {
                templateUrl: 'components/auth/reset-password/resetPasswordView.html',
                controller: 'ResetPasswordCtrl',
                controllerAs: 'vm'
            })

            .when('/set-password/:token', {
                templateUrl: 'components/auth/set-password/setPasswordView.html',
                controller: 'SetPasswordCtrl',
                controllerAs: 'vm'
            })

            .when('/responses', {
                templateUrl: 'components/responses/search/search.template.html',
                controller: 'ResponseSearchCtrl',
                controllerAs: 'vm',
                resolve: {
                    surveys: ['responseFactory', function(responseFactory) {
                        return responseFactory.query();
                    }]
                }
            })

            .when('/responses/:code', {
                templateUrl: 'components/responses/list/list.template.html',
                controller: 'ResponseResponseListCtrl',
                controllerAs: 'vm',
                resolve: {
                    summary: ['$route', 'responseFactory', function($route, responseFactory) {
                        return responseFactory.summary($route.current.params.code);
                    }],
                    responses: ['$route', 'responseFactory', function($route, responseFactory) {
                        return responseFactory.responses($route.current.params.code);
                    }]
                }
            })

            .when('/responses/:code/free-responses', {
                templateUrl: 'components/responses/free-responses/free-responses.template.html',
                controller: 'ResponseFreeResponseListCtrl',
                controllerAs: 'vm',
                resolve: {
                    answers: ['$route', 'responseFactory', function($route, responseFactory) {
                        return responseFactory.freeResponses($route.current.params.code);
                    }]
                }
            })

            .when('/responses/:code/answers/:id', {
                templateUrl: 'components/responses/answers/answer.template.html',
                controller: 'ResponseResponseAnswerCtrl',
                controllerAs: 'vm',
                resolve: {
                    summary: ['$route', 'responseFactory', function($route, responseFactory) {
                        return responseFactory.summary($route.current.params.code);
                    }],
                    answers: ['$route', 'responseFactory', function($route, responseFactory) {
                        return responseFactory.answers($route.current.params.code, $route.current.params.id);
                    }]
                }
            })

            .when('/reports', {
                templateUrl: 'components/reports/search/searchView.html',
                controller: 'ReportSearchCtrl',
                controllerAs: 'vm',
                resolve: {
                    reports: ['reportFactory', function(reportFactory) {
                        return reportFactory.query();
                    }]
                }
            })

            .when('/bulk-export', {
                templateUrl: 'components/bulk-export/selectionView.html',
                controller: 'BulkExportCtrl',
                controllerAs: 'vm'
            })

            .when('/surveys', {
                templateUrl: 'components/surveys/search/search.template.html',
                controller: 'SurveySearchController',
                controllerAs: 'vm',
                resolve: {
                    surveys: ['surveyFactory', function(surveyFactory) {
                        return surveyFactory.all();
                    }]
                }
            })

            .when('/surveys/:id/questions', {
                templateUrl: 'components/surveys/questions/question.template.html',
                controller: 'SurveyQuestionController',
                controllerAs: 'vm',
                resolve: {
                    survey: ['$route', 'surveyFactory', function($route, surveyFactory) {
                        return surveyFactory.find($route.current.params.id);
                    }],

                    questions: ['$route', 'surveyFactory', function($route, surveyFactory) {
                        return surveyFactory.questions($route.current.params.id);
                    }]
                }
            })

            .when('/users', {
                templateUrl: 'components/users/search/searchView.html',
                controller: 'UserSearchCtrl',
                controllerAs: 'vm',
                resolve: {
                    users: ['userFactory', function(userFactory) {
                        return userFactory.query();
                    }]
                }
            })

            .when('/users/create', {
                templateUrl: 'components/users/create/createView.html',
                controller: 'UserCreateCtrl',
                controllerAs: 'vm'
            })

            .when('/users/:id', {
                templateUrl: 'components/users/update/updateView.html',
                controller: 'UserUpdateCtrl',
                controllerAs: 'vm',
                resolve: {
                    user: ['$route', 'userFactory', function($route, userFactory) {
                        return userFactory.find($route.current.params.id);
                    }]
                }
            });
    }
]);
